import ImageLayer from "../ImageLayer";
import { LayerCustomType } from "../../interfaces";
import { CrosswordLayerProps, CrosswordProps } from "./interfaces";

export default class CrosswordLayer extends ImageLayer {
  protected static customType: LayerCustomType = LayerCustomType.Crossword;
  protected static defaultTypeProps: Partial<CrosswordProps> = {
    words: "Susan Laura Ryan Paul",
    color: "#000",
    spacing: 0,
    fontSizePercent: 75,
    showScore: true,
    algorithm: "beam_search",
  };

  name: string = "Crossword layer";
  crosswordProps: Partial<CrosswordProps>;

  constructor(options: Partial<CrosswordLayerProps> = {}) {
    const {
      transformSettings = {},
      typeSettings = {},
      ...layerProps
    } = options;
    super();

    this.crosswordProps = {
      ...CrosswordLayer.defaultTypeProps,
      ...typeSettings,
    };

    this.set(transformSettings);
    this.set(layerProps);
  }

  toObject() {
    const object = super.toObject();
    const crosswordProps = this.getCrosswordProps();
    return { ...object, typeSettings: crosswordProps };
  }

  setCrosswordProps(props: Partial<CrosswordProps>) {
    this.crosswordProps = { ...this.crosswordProps, ...props };
    this.rerender();
  }

  getCrosswordProps(key?: keyof CrosswordProps) {
    if (key) {
      return this.crosswordProps?.[key];
    } else {
      return { ...this.crosswordProps };
    }
  }
}

export * from "./interfaces";
